module.exports = new __parcel__URL__("base_raid_back_to_home_btn.e5f58d2f.png").toString();